import axios from "../../utils/axios";

const getDefaultState = () => {
    return {
        snapshot_data: null,
        snapshotfolder: null,
        snapshotpict: null,
        loadingimage: null,
        loadingfolder: null,
        vesselData: null,
        filterlist: null,
        folder_select: null,
        snapshot_executed: false,
        snapshotclick:null,
        dirLabel_:null
    }
}

const state = getDefaultState();

const getters = {
    folderSelect: (state) => state.folder_select,
    snapshotData: (state) => state.snapshot_data,
    filterList: (state) => state.filterlist,
    snapshotfolder: (state) => state.snapshotfolder,
    snapshotpict: (state) => state.snapshotpict,
    loadingimage: (state) => state.loadingimage,
    loadingfolder: (state) => state.loadingfolder,
    vesselData: (state) => state.vesselData,
    snapshot_executed:(state)=>state.snapshot_executed,
    snapshotclick:(state)=>state.snapshotclick,
    dirLabel_:(state)=>state.dirLabel_
};

const actions = {
    async fetchSnapshot({commit}, data) {
        const response = await axios.get(
            "/api/v1/navplus/snapshot",
            {
                headers: {
                    Authorization: "Bearer" + data,
                },
            }
        );
        console.log(response.data.data.vessels);
        commit("setSnapshot", response.data.data.vessels.map((item, index) =>
            Object.assign(item, {index})
        ));
    },

    async snapshotFolder({commit}, data) {
        commit('setsnapshotclick',true)
        commit('setloadingfolder', null)
        commit('setsnapshotfolder', null)
        commit('setsnapshotpict', null)
        commit('setfilterlist', null)
        commit('setloadingimage', true)
        

        try{
        const response = await axios.get(
            "/api/v1/navplus/snapshot/" + data.id,
            {
                headers: {
                    Authorization: "Bearer" + data.token
                },
            }
        );
        commit('setloadingfolder', true)
        commit('setsnapshotfolder', response.data.data)
        commit('setfilterlist', response.data.data.list)
        commit('folderonSelect', response.data.data.dir_label[0])
        var dirLabel =   response.data.data.dir_label.map((p) => ({
            ...p,
            label_search: p,
        }));
        commit('setdirLabel_',dirLabel)
        commit("setsnapshot_executed", false)

        const responsepict = await axios.get(
            "/api/v1/navplus/snapshot/" + data.id + "/" + response.data.data.dir_label[0],
            {
                headers: {
                    Authorization: "Bearer" + data.token,
                },
            }
        );


        
        commit('setsnapshotpict', responsepict.data.data)
        commit("setsnapshot_executed", false)

        }catch(error){
            console.log(error)
        }

    },


    async showSnapshot_({commit}, data) {
        console.log('SHOW SNAPSOT KLIK')
        commit('setsnapshotfolder', null)
        commit('setsnapshotpict', null)

        const response = await axios.get(
            "/api/v1/navplus/snapshot/" + data.id,
            {
                headers: {
                    Authorization: "Bearer" + data.token
                },
            }
        );
        console.log(response.data.data)
        commit('setsnapshotfolder', response.data.data)
        // commit('folderonSelect', response.data.data.dir_label[0])
        const responsepict = await axios.get(
            "/api/v1/navplus/snapshot/" + data.id + "/" + response.data.data.dir_label[0],
            {
                headers: {
                    Authorization: "Bearer" + data.token,
                },
            }
        );
        console.log(responsepict)
        // try {
        //     commit('setsnapshotpict', responsepict.data.data)
        // }
        // catch (e) {
        //     console.log("Local Storage is full, Please empty data");
        //     localStorage.removeItem('vuex');
        // }

        commit('setsnapshotpict', responsepict.data.data)
       
       
        
    },

    addsnapshot_executed({commit}, data) {
        commit("setsnapshot_executed", data)
    },

    async FolderClick({commit}, data) {
        //console.log(data.id)
        commit('setsnapshotpict', null)
        commit('setloadingimage', true)
        commit('folderonSelect', data.label)
        const response = await axios.get(
            "/api/v1/navplus/snapshot/" + data.id + "/" + data.label,
            {
                headers: {
                    Authorization: "Bearer" + data.token,
                },
            }
        );
        //console.log(response)
        commit('setsnapshotpict', response.data.data)
    },


    async FilterClick({commit}, data) {
        //console.log(data.id)
        commit('setsnapshotpict', null)
        commit('setloadingimage', true)
        const response = await axios.get(
            "/api/v1/navplus/snapshot/" + data.id + "/" + data.label + "/" + data.ch,
            {
                headers: {
                    Authorization: "Bearer" + data.token,
                },
            }
        );
        //console.log(response)
        commit('setsnapshotpict', response.data.data)
    },

    vesselDataSet({commit}, data) {
        //console.log(data)
        commit('setvesselData', data)
    },


    closeShow({commit}) {
        //console.log('CLOSE SHOW SNAPSHOT')
        commit('setsnapshotclick',null)
        commit('setloadingfolder', null)
        commit('folderonSelect', null)
        commit('setsnapshotfolder', null)
        commit('setfilterlist', null)
        commit('setsnapshotpict', null)
        commit('setloadingimage', null)
        commit('setvesselData', null)
    },

    resetSnapshotState({commit}) {
        commit("resetState");
    },

};

const mutations = {
    setdirLabel_:(state, dirLabel_)=>(state.dirLabel_ =  dirLabel_),
    folderonSelect: (state, folderonselect) => (state.folder_select = folderonselect),
    setsnapshotclick:(state,snapshotclick)=>(state.snapshotclick = snapshotclick),
    setsnapshot_executed: (state, snapshot_executed) => (state.snapshot_executed = snapshot_executed),
    setSnapshot: (state, snapshot) => (state.snapshot_data = snapshot),
    setsnapshotfolder: (state, snapshotfolder) => (state.snapshotfolder = snapshotfolder),
    setfilterlist: (state, filterlist) => (state.filterlist = filterlist),
    setsnapshotpict: (state, snapshotpict) => (state.snapshotpict = snapshotpict),
    setloadingimage: (state, loadingimage) => (state.loadingimage = loadingimage),
    setloadingfolder: (state, loadingfolder) => (state.loadingfolder = loadingfolder),
    setvesselData: (state, vesselData) => (state.vesselData = vesselData),
    resetState(state) {
        Object.assign(state, getDefaultState());
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
